// extracted by mini-css-extract-plugin
export default {"consoleButton":"KeyModal_consoleButton__MYF5q","footer":"KeyModal_footer__PLaEI","consoleAlert":"KeyModal_consoleAlert__8q3kW","footerButtons":"KeyModal_footerButtons__Qttkd"};